import React, { useEffect, useState } from "react";
import "./Agents.css";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { submitRenewalRequest } from "../../../../store/features/actions/renewalAgentActions";
import { submitGetLiveAccountsRequest } from "../../../../store/features/actions/fetchLiveAccountsActions";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import * as FeatherIcon from "react-feather";

export default function Renewal({
  contentRef = null,
  copied = false,
  handleCopy = () => {},
  exportTablesToCSV = () => {}
}) {
  const { accountName } = useParams();
  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(state => state.renewalReducer);
  const { successData } = useSelector(state => state.getLiveAccountsReducer);

  const [contact, setContact] = useState("");
  const [consumptionFile, setConsumptionFile] = useState(null);
  const [outputFile, setOutputFile] = useState(null);

  const [contactError, setContactError] = useState("");
  const [consumptionFileError, setConsumptionFileError] = useState("");
  const [outputFileError, setOutputFileError] = useState("");
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [company, setCompany] = useState("");
  const [liveCompanyEnabled, setLiveCompanyEnabled] = useState(false);

  useEffect(() => {
    dispatch(submitGetLiveAccountsRequest({account_name: accountName}));
  }, []);

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    const fieldName = e.target.name;
  
    if (!uploadedFile) return;
  
    const validCsvType = "text/csv";
    const validOutputTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];
  
    if (fieldName === "consumptionFile") {
      if (uploadedFile.type === validCsvType) {
        setConsumptionFile(uploadedFile);
        setConsumptionFileError("");
      } else {
        setConsumptionFile(null);
        setConsumptionFileError("Only CSV files are allowed.");
      }
    } else if (fieldName === "outputFile") {
      if (validOutputTypes.includes(uploadedFile.type)) {
        setOutputFile(uploadedFile);
        setOutputFileError("");
      } else {
        setOutputFile(null);
        setOutputFileError("Only PDF or DOCX files are allowed.");
      }
    }
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;

    if (!contact) {
      setContactError("Contact is required.");
      isValid = false;
    } else {
      setContactError("");
    }

    if (!consumptionFile && !company) {
      setConsumptionFileError("Either Consumption File or Live Company is required.");
      isValid = false;
    } else {
      setConsumptionFileError("");
    }

    if (isValid === false) return;

    const formData = {
      accountName: accountName,
      contact: contact,
      consumptionFile: consumptionFile,
      outputFile: outputFile,
      account_id: company
    };

    dispatch(submitRenewalRequest(formData));

    setTimeout(function(){
      setShowMoreModal(true);
    }, successMessage);

  };

  let names = [];
  if(accountName === "MOOG INC"){
    names = [
      "Patrick J Roche",
      "Jennifer Walter",
      "Paul Wilkinson",
      "Joe Alfieri",
      "Stu McLachlan",
      "Mark Graczyk",
      "Michael Schaff",
    ];    
  } else if (accountName === "PANASONIC CORPORATION"){
    names = [
      "Yuki Kusumi",
      "Tetsuro Homma",
      "Hajime Tamaoki",
      "Tatsuo Kinoshita",
      "Megan Myungwon Lee",
      "Tatsuo Ogawa",
      "Ayako Shotoku",
      "Shigeo Usui",
      "Akira Waniko",
    ];
  } else if (accountName === "VALVOLINE INC"){
    names = [
      "Valvoline contacts",
      "Lori flees",
      "Mary Meixelsperger",
      "Linne Fulcher",
      "Adam Worsham",
      "Brian Tabb",
      "Travis Dobbins",
      "Chris Calabrese",
      "Joe Certo",
      "Keith Peshke"
    ];
  } else {
    names = [];
  }

  return (
    <div className="custom_card_block mb-2 mt-4">
      <div className="closure_note_wrapper">
        <div className="head_top">
          <h5 className="main_head">Renewal Note</h5>
        </div>
        <div className="closure_block mt-3">
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label">Select Contact <span className='red'>*</span></Form.Label>
                  {/* <Form.Label className="custom_agentform_label">Select Contact</Form.Label> */}
                  <Form.Select
                    className="custom_agentform_control"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  >
                    <option value="">Select Contact</option>
                    {names.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </Form.Select>
                  {contactError && <p className="text-danger">{contactError}</p>}
                </Form.Group>
              </div>
              </div>

              <div className="row">

              <div className="col-md-6">
                <Form.Group className="mb-3 custom_agentform_group">
                  <Form.Label className="custom_agentform_label">Select Company</Form.Label>
                  <Form.Control
                    as="select"
                    name="liveCompany"
                    className="form-control  custom_agentform_control"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    disabled={!liveCompanyEnabled}
                  >
                    <option value="">Select Company</option>
                    {Object.values(successData).map((company, index) => (
                      <option key={`sel-status-${company.id}`} value={company.id}>
                        {company.company_name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                </div>
                <div className="col-md-6">
                  <p className="decision_span">
                  <input
                    className="form-check-input custom_input_type input_decision"
                    type="checkbox"
                    name="live_company_enabler"
                    checked={liveCompanyEnabled}
                    onChange={(e) => setLiveCompanyEnabled(e.target.checked)}
                  /> 
                  <span className="ml-1">Include KS Consumption Data?</span>

                  </p>
                </div>
               </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3 custom_agentform_group">
                    {/* <Form.Label className="custom_agentform_label d-block">Consumption Data <span className='red'>*</span></Form.Label> */}
                    <Form.Label className="custom_agentform_label d-block">Consumption Data</Form.Label>
                    <input type="file" name="consumptionFile" className="custom_agentform_file" onChange={handleFileChange} />
                    {consumptionFileError && <p className="text-danger">{consumptionFileError}</p>}
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3 custom_agentform_group">
                    {/* <Form.Label className="custom_agentform_label d-block">Output File <span className='red'>*</span></Form.Label> */}
                    <Form.Label className="custom_agentform_label d-block">Output File</Form.Label>
                    <input type="file" name="outputFile" className="custom_agentform_file" onChange={handleFileChange} />
                    {outputFileError && <p className="text-danger">{outputFileError}</p>}
                  </Form.Group>
                </div>
              </div>

              <div className="col-md-12">
                <div className="prev_next_block">
                  <button type="submit" className="genrate_modal_btn btn btn-primary" disabled={loading}>
                    {loading ? "Submitting..." : "Generate"}
                  </button>
                  <button 
                    type="reset" 
                    className="btn btn-secondary cancel_modal_btn" 
                    onClick={() => {
                      setContact("");
                      setContactError("");
                      setConsumptionFile(null);
                      setConsumptionFileError("");
                      setOutputFile(null);
                      setOutputFileError("");
                      setCompany("");
                      setLiveCompanyEnabled(false);
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>

              {errorMessage && <p className="text-danger">{errorMessage}</p>}
              {/* {successMessage && <p className="text-success">{successMessage}</p>} */}
          </Form>
        </div>
      </div>

      {showMoreModal && successMessage && (
        <GenericOverviewSideCard
          showMoreModal={showMoreModal}
          setShowMoreModal={setShowMoreModal}
          titleForSideCard={
            <div
              className="promters_head"
              style={{
                display:"flex",
                justifyContent:"space-between"
              }}
            >
                                          <div className="clousre_head">

              <h5 style={{marginRight: "5px"}}>
                Renewal Note
              </h5>
              </div>
              <div className="copy_clousre">

              <span>
                <FeatherIcon.Copy
                  className="copy_note fa"
                  onClick={handleCopy}
                />
                <span
                  className={`copy-message ${
                    copied ? "copy-fade-in" : "copy-fade-out"
                  }`}
                >
                  Note Copied !
                </span>
                {/* <img
                  src="/img/icons/copy.png"
                  onClick={exportTablesToCSV}
                  alt="csv"
                  width="20"
                  class=""
                >
                </img> */}
              </span>
            </div>
            </div>

          }
          comp={
          <div ref={contentRef}>
            <div className="row">
              <div className="col-md-3">
                <p className="overview_head_agents">Persona Name:</p>
              </div>
              <div className="col-md-9 subhead_content">
                {contact}
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-3">
                <p className="overview_head_agents">Context:</p>
              </div>
              <div className="col-md-9 subhead_content">
                {context}
              </div>
            </div> */}
            <div className="closure_result mt-4" dangerouslySetInnerHTML={{ __html: successMessage }} />
          </div>
        }/>
      )}

    </div>
  );
}
